// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-wrapper{
    width: 50px;
    height: 50px;
}

.loader-container{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
}

.ld-ring{
    font-size : 50px;
    color: #eaeaea;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loading-state/loading-state.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".loader-wrapper{\n    width: 50px;\n    height: 50px;\n}\n\n.loader-container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n}\n\n.ld-ring{\n    font-size : 50px;\n    color: #eaeaea;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
